import { render, staticRenderFns } from "./template-dialog.vue?vue&type=template&id=c23a0a6a"
import script from "./template-dialog.vue?vue&type=script&lang=js"
export * from "./template-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports